import { render, staticRenderFns } from "./NewInscription.view.vue?vue&type=template&id=10425334"
import script from "./NewInscription.view.vue?vue&type=script&lang=js"
export * from "./NewInscription.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports